import {Api} from './config/request';

const getTeachers = (params) => (Api.getFliveRequest(`teachers/${params}`,true))
const getSearchResult = (params) => (Api.getSearchRequest(`global-search/v1/?${params}`,false))
const getLevels = () => (Api.getRequest(`misc/v1/level/`,false))
export const TeacherApiCalls = {
    getTeachers,
    getSearchResult,
    getLevels   
}